var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCoins = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#coins_svg__a)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 31,
  cy: 35,
  r: 11.878,
  fill: "url(#coins_svg__b)",
  transform: "rotate(-.592 31 35)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 29,
  cy: 35,
  r: 11.878,
  fill: "url(#coins_svg__c)",
  transform: "rotate(-.592 29 35)"
}), /*#__PURE__*/React.createElement("g", {
  filter: "url(#coins_svg__d)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 29.442,
  cy: 35.442,
  r: 7,
  fill: "url(#coins_svg__e)"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#F19E50",
  d: "M29.442 40.971a.307.307 0 0 1-.308-.307v-9.062a.307.307 0 0 1 .615 0v9.062c0 .17-.138.307-.307.307m2.177-6.773c-.238 0-.426-.185-.527-.4a1.2 1.2 0 0 0-.436-.493q-.48-.317-1.177-.317-.51 0-.892.166-.378.166-.591.458-.21.29-.21.661 0 .31.146.533.15.22.382.367.232.144.487.238.255.09.468.147l.78.212q.3.08.666.22.372.14.709.381.34.238.561.612.221.375.221.919 0 .627-.325 1.134-.322.507-.945.805-.617.3-1.502.299-.824 0-1.427-.269a2.3 2.3 0 0 1-.944-.748 2 2 0 0 1-.296-.607c-.08-.268.147-.508.427-.508.25 0 .446.198.545.428q.071.165.19.297.258.284.651.424.398.136.854.136.532 0 .956-.174.423-.177.67-.491.247-.318.247-.741 0-.385-.213-.628a1.6 1.6 0 0 0-.562-.393 6 6 0 0 0-.753-.264l-.944-.273q-.9-.26-1.424-.744-.525-.484-.524-1.267 0-.65.348-1.134a2.3 2.3 0 0 1 .944-.756q.595-.272 1.33-.272.742 0 1.319.269.577.264.914.725.196.265.285.572c.075.253-.144.475-.408.475"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 34,
  cy: 12,
  r: 11.878,
  fill: "url(#coins_svg__f)",
  transform: "rotate(-.592 34 12)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 32,
  cy: 12,
  r: 11.878,
  fill: "url(#coins_svg__g)",
  transform: "rotate(-.592 32 12)"
}), /*#__PURE__*/React.createElement("g", {
  filter: "url(#coins_svg__h)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 32.442,
  cy: 12.442,
  r: 7,
  fill: "url(#coins_svg__i)"
})), /*#__PURE__*/React.createElement("circle", {
  cx: 18,
  cy: 20,
  r: 11.878,
  fill: "url(#coins_svg__j)",
  transform: "rotate(-.592 18 20)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 16,
  cy: 20,
  r: 11.878,
  fill: "url(#coins_svg__k)",
  transform: "rotate(-.592 16 20)"
}), /*#__PURE__*/React.createElement("g", {
  filter: "url(#coins_svg__l)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 16.442,
  cy: 20.442,
  r: 7,
  fill: "url(#coins_svg__m)"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#F19E50",
  d: "M16.442 25.971a.307.307 0 0 1-.308-.307v-9.062a.307.307 0 0 1 .615 0v9.062c0 .17-.138.307-.307.307m2.177-6.773c-.238 0-.426-.185-.527-.4a1.2 1.2 0 0 0-.436-.493q-.48-.317-1.177-.317-.51 0-.891.166-.38.167-.592.458-.21.29-.21.661 0 .31.146.533.15.219.382.367.232.144.487.238.255.09.468.147l.78.212q.3.08.666.22.372.14.709.381.34.238.561.612.221.375.221.919 0 .627-.325 1.134-.322.507-.945.805-.617.3-1.502.299-.825 0-1.427-.269a2.3 2.3 0 0 1-.944-.748 2 2 0 0 1-.296-.607c-.08-.268.147-.508.427-.508.25 0 .446.198.545.428q.071.165.19.297.258.284.651.424.398.136.854.136.532 0 .956-.174.423-.177.67-.491.247-.318.247-.741 0-.385-.213-.628a1.6 1.6 0 0 0-.562-.393 6 6 0 0 0-.753-.264l-.944-.273q-.9-.261-1.424-.744-.524-.484-.524-1.267 0-.65.348-1.134a2.3 2.3 0 0 1 .944-.756q.595-.272 1.33-.272.742 0 1.319.269.577.264.914.725.196.265.285.572c.075.253-.144.476-.408.476M32.265 17.677a.307.307 0 0 1-.307-.307V8.307a.307.307 0 0 1 .614 0v9.063c0 .17-.138.307-.307.307m2.177-6.774c-.237 0-.426-.184-.527-.4a1.2 1.2 0 0 0-.436-.492q-.48-.318-1.177-.318-.51 0-.891.167-.38.165-.592.457-.21.291-.21.662a.95.95 0 0 0 .146.533q.15.219.382.366.232.144.487.238.255.09.469.148l.779.212q.3.078.667.219.37.14.708.382.34.237.562.612.22.375.22.918 0 .628-.325 1.135-.323.505-.944.805-.619.298-1.503.298-.825 0-1.427-.268a2.3 2.3 0 0 1-.944-.749 2 2 0 0 1-.296-.607c-.08-.268.148-.508.427-.508.25 0 .446.199.545.428q.071.165.19.298.258.284.651.423.398.136.854.136.532 0 .956-.173a1.64 1.64 0 0 0 .67-.492 1.17 1.17 0 0 0 .247-.74q0-.387-.213-.628a1.6 1.6 0 0 0-.562-.393 6 6 0 0 0-.753-.265l-.944-.272q-.9-.26-1.424-.745-.525-.483-.524-1.266 0-.65.348-1.134.353-.487.944-.756.595-.272 1.33-.272.742 0 1.319.268.578.266.914.726.196.265.285.571c.075.254-.144.476-.408.476"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "coins_svg__b",
  x1: 23.64,
  x2: 40.432,
  y1: 21.423,
  y2: 41.598,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F3F6F5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.547,
  stopColor: "#F1C181"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FE7701"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "coins_svg__c",
  x1: 20.573,
  x2: 38.432,
  y1: 27.913,
  y2: 41.598,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FEF0AE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.547,
  stopColor: "#FEE8A3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F09642"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "coins_svg__e",
  x1: 24.427,
  x2: 35.399,
  y1: 31.271,
  y2: 40.133,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FEF0AE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.556,
  stopColor: "#F6CC86"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F47E19"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "coins_svg__f",
  x1: 26.64,
  x2: 43.432,
  y1: -1.577,
  y2: 18.598,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F3F6F5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.547,
  stopColor: "#F1C181"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FE7701"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "coins_svg__g",
  x1: 23.573,
  x2: 41.432,
  y1: 4.912,
  y2: 18.598,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FEF0AE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.547,
  stopColor: "#FEE8A3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F09642"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "coins_svg__i",
  x1: 27.427,
  x2: 38.399,
  y1: 8.271,
  y2: 17.133,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FEF0AE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.556,
  stopColor: "#F6CC86"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F47E19"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "coins_svg__j",
  x1: 10.64,
  x2: 27.432,
  y1: 6.423,
  y2: 26.598,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F3F6F5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.547,
  stopColor: "#F1C181"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FE7701"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "coins_svg__k",
  x1: 7.573,
  x2: 25.432,
  y1: 12.912,
  y2: 26.598,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FEF0AE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.547,
  stopColor: "#FEE8A3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F09642"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "coins_svg__m",
  x1: 11.427,
  x2: 22.399,
  y1: 16.271,
  y2: 25.133,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FEF0AE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.556,
  stopColor: "#F6CC86"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F47E19"
})), /*#__PURE__*/React.createElement("filter", {
  id: "coins_svg__d",
  width: 83.786,
  height: 18.997,
  x: 20.754,
  y: 25.195,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 67.515,
  dy: 1.167
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.292
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.952941 0 0 0 0 0.737255 0 0 0 0 0.454902 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  mode: "color",
  result: "effect1_dropShadow_2556_6470"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feMorphology", {
  in: "SourceAlpha",
  operator: "dilate",
  radius: 1.688,
  result: "effect2_dropShadow_2556_6470"
}), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.988235 0 0 0 0 0.815686 0 0 0 0 0.494118 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "effect1_dropShadow_2556_6470",
  result: "effect2_dropShadow_2556_6470"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect2_dropShadow_2556_6470",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: -3.247
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 3.49
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  k2: -1,
  k3: 1,
  operator: "arithmetic"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.945098 0 0 0 0 0.552941 0 0 0 0 0.211765 0 0 0 0.4 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "shape",
  result: "effect3_innerShadow_2556_6470"
})), /*#__PURE__*/React.createElement("filter", {
  id: "coins_svg__h",
  width: 83.786,
  height: 18.35,
  x: 23.754,
  y: 2.842,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 67.515,
  dy: 1.167
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.292
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.952941 0 0 0 0 0.737255 0 0 0 0 0.454902 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  mode: "color",
  result: "effect1_dropShadow_2556_6470"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feMorphology", {
  in: "SourceAlpha",
  operator: "dilate",
  radius: 1.688,
  result: "effect2_dropShadow_2556_6470"
}), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.988235 0 0 0 0 0.815686 0 0 0 0 0.494118 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "effect1_dropShadow_2556_6470",
  result: "effect2_dropShadow_2556_6470"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect2_dropShadow_2556_6470",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: -3.247
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 1.3
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  k2: -1,
  k3: 1,
  operator: "arithmetic"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.94902 0 0 0 0 0.576471 0 0 0 0 0.235294 0 0 0 0.4 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "shape",
  result: "effect3_innerShadow_2556_6470"
})), /*#__PURE__*/React.createElement("filter", {
  id: "coins_svg__l",
  width: 83.786,
  height: 18.997,
  x: 7.754,
  y: 10.195,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 67.515,
  dy: 1.167
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.292
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.952941 0 0 0 0 0.737255 0 0 0 0 0.454902 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  mode: "color",
  result: "effect1_dropShadow_2556_6470"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feMorphology", {
  in: "SourceAlpha",
  operator: "dilate",
  radius: 1.688,
  result: "effect2_dropShadow_2556_6470"
}), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.988235 0 0 0 0 0.815686 0 0 0 0 0.494118 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "effect1_dropShadow_2556_6470",
  result: "effect2_dropShadow_2556_6470"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect2_dropShadow_2556_6470",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: -3.247
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 1.85
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  k2: -1,
  k3: 1,
  operator: "arithmetic"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.929412 0 0 0 0 0.52549 0 0 0 0 0.207843 0 0 0 0.53 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "shape",
  result: "effect3_innerShadow_2556_6470"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "coins_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h48v48H0z"
})))));
export default SvgCoins;